import { EventProxy } from '../utils/eventProxy';
import { generatePluginEventListenerCallbackParams } from '../actionParams';

const hotAreaEventListeners = new EventProxy();

export function onHotArea(eventType, callback) {
  hotAreaEventListeners.on(eventType, callback);
}

export function emitHotArea(e, eventType, hotArea, instance, meta, global) {
  const params = generatePluginEventListenerCallbackParams(eventType, global, meta, instance, hotArea);
  if (e) {
    params.originalEvent = e;
  }
  hotAreaEventListeners.emit(eventType, params);
}
